define('modules/Cart/CartSelectedBranch',[
        'jquery',
        'global/all',
        'plugins/jquery.proxyRequest'
    ],
    function ($, Roc) {
        'use strict';

        function changeBranch(branchId) {
            return $.proxyRequest({
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                url: 'api/store/cart/{orderId}/branch/' + branchId,
                complete: function (xhr) {
                    Roc.Logger.info('CartSelectedBranch -> changeBranch');
                    Roc.Logger.info(xhr);
                }
            });
        }

        var CartSelectedBranch = {
            changeBranch: changeBranch
        };

        Roc.Logger.debug('CartSelectedBranch.js Loaded:', CartSelectedBranch);

        return CartSelectedBranch;


    });
